import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PasswordResetComponent } from './password-reset.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'set_password', component: PasswordResetComponent
      }
    ])
  ],
  declarations: [],
  exports: [RouterModule]
})
export class PasswordResetRoutingModule { }
